import deliveryDateClass from "common/utils/delivery-date/delivery-date-class";
import { EventBus, Events } from "jiffy-store";

export default function initHero() {
  const deliveryDate = deliveryDateClass();
  deliveryDate.init();

  EventBus.on(Events.ZIPCODE_UPDATED, () => {
    deliveryDate.init();
  });
}
